import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import API_BASE from "../config/api";

export default function WebAboutMe() {

    const user = JSON.parse(localStorage.getItem("user"));
    const personaluid = user.personaluid;

    const [domain, setDomain] = useState("");

    const [formData, setFormData] = useState({
        aboutme: "",
        nationality: "",
        currentjob: "",
        experience: "",
        pastjob: "",
        mobile: "",
        whatsapp: "",
        email: "",
        languages: "",
        aboutimg: null
    });

    const showToast = (message, icon) => {
        Swal.fire({
            toast: true,
            position: "top-end",
            icon: icon,
            title: message,
            showConfirmButton: false,
            timer: 1500
        });
    };

    // LOAD DATA
    useEffect(() => {
        fetch(`${API_BASE}/api/get_webabout.php?personaluid=${personaluid}`)
            .then(res => res.json())
            .then(data => {
                if (data.success && data.data) {
                    setDomain(data.domain);
                    setFormData({
                        aboutme: data.data.aboutme,
                        nationality: data.data.nationality,
                        currentjob: data.data.currentjob,
                        experience: data.data.experience,
                        pastjob: data.data.pastjob,
                        mobile: data.data.mobile,
                        whatsapp: data.data.whatsapp,
                        email: data.data.email,
                        languages: data.data.languages,
                        aboutimg: null
                    });
                } else if (data.domain) {
                    setDomain(data.domain);
                }
            });
    }, []);

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        setFormData({
            ...formData,
            [name]: files ? files[0] : value
        });
    };

    // SAVE DATA
    const handleSubmit = (e) => {
        e.preventDefault();

        const fd = new FormData();
        fd.append("personaluid", personaluid);
        fd.append("domain", domain);

        // Map formData keys to API expected fields
        fd.append("description", formData.aboutme);
        fd.append("nationality", formData.nationality);
        fd.append("cjob", formData.currentjob);
        fd.append("worktime", formData.experience);
        fd.append("pjob", formData.pastjob);
        fd.append("mobile", formData.mobile);
        fd.append("whatsapp", formData.whatsapp);
        fd.append("email", formData.email);
        fd.append("languages", formData.languages);

        if (formData.aboutimg) {
            fd.append("profilepics", formData.aboutimg);
        }

        fetch(`${API_BASE}/api/save_webabout.php`, {
            method: "POST",
            body: fd
        })
            .then(res => res.json())
            .then(data => {
                showToast(data.message, data.success ? "success" : "error");
            });
    };

    return (
        <div className="container-fluid px-4 py-3">

            {/* PAGE HEADER */}
            <div className="rounded p-3 mb-3 shadow-sm"
                style={{
                    background: "linear-gradient(135deg, #e8f0ff, #fefefe)",
                    borderLeft: "6px solid #4a90e2"
                }}>
                <h5 className="fw-bold text-dark mb-1">Website – About Me</h5>
                <p className="text-secondary mb-0">Update your website contents.</p>
            </div>

            {/* FORM CARD */}
            <div className="card shadow-sm border-0 mb-4">
                <div className="card-body">

                    <form autoComplete="off" onSubmit={handleSubmit} encType="multipart/form-data">

                        {/* ABOUT ME */}
                        <div className="mb-3">
                            <label className="form-label fw-semibold">Short Description *</label>
                            <textarea
                                name="aboutme"
                                className="form-control form-control-sm"
                                rows="5"
                                value={formData.aboutme}
                                onChange={handleChange}
                            ></textarea>
                        </div>

                        {/* ROW 1 */}
                        <div className="row">
                            <div className="col-md-4 mb-3">
                                <label className="form-label fw-semibold">Nationality *</label>
                                <input type="text" name="nationality" className="form-control form-control-sm"
                                    value={formData.nationality} onChange={handleChange} />
                            </div>

                            <div className="col-md-4 mb-3">
                                <label className="form-label fw-semibold">Current Job *</label>
                                <input type="text" name="currentjob" className="form-control form-control-sm"
                                    value={formData.currentjob} onChange={handleChange} />
                            </div>

                            <div className="col-md-4 mb-3">
                                <label className="form-label fw-semibold">Experience *</label>
                                <input type="text" name="experience" className="form-control form-control-sm"
                                    value={formData.experience} onChange={handleChange} />
                            </div>
                        </div>

                        {/* ROW 2 */}
                        <div className="row">
                            <div className="col-md-4 mb-3">
                                <label className="form-label fw-semibold">Past Job *</label>
                                <input type="text" name="pastjob" className="form-control form-control-sm"
                                    value={formData.pastjob} onChange={handleChange} />
                            </div>

                            <div className="col-md-4 mb-3">
                                <label className="form-label fw-semibold">Phone *</label>
                                <input type="text" name="mobile" className="form-control form-control-sm"
                                    value={formData.mobile} onChange={handleChange} />
                            </div>

                            <div className="col-md-4 mb-3">
                                <label className="form-label fw-semibold">Whatsapp *</label>
                                <input type="text" name="whatsapp" className="form-control form-control-sm"
                                    value={formData.whatsapp} onChange={handleChange} />
                            </div>
                        </div>

                        {/* ROW 3 */}
                        <div className="row">
                            <div className="col-md-4 mb-3">
                                <label className="form-label fw-semibold">Email *</label>
                                <input type="email" name="email" className="form-control form-control-sm"
                                    value={formData.email} onChange={handleChange} />
                            </div>

                            <div className="col-md-4 mb-3">
                                <label className="form-label fw-semibold">Languages *</label>
                                <input type="text" name="languages" className="form-control form-control-sm"
                                    value={formData.languages} onChange={handleChange} />
                            </div>

                            <div className="col-md-4 mb-3">
                                <label className="form-label fw-semibold">Profile Picture</label>
                                <input type="file" accept="image/*" name="aboutimg"
                                    className="form-control form-control-sm"
                                    onChange={handleChange} />
                            </div>
                        </div>

                        {/* SUBMIT */}
                        <div className="text-end">
                            <button className="btn btn-primary px-4 mt-2">
                                <i className="bi bi-cloud-upload-fill me-1"></i>
                                Update
                            </button>
                        </div>

                    </form>

                </div>
            </div>

        </div>
    );
}
